// src/utils/encryption.js
import CryptoJS from 'crypto-js';

// La clave secreta debe estar en variables de entorno (no hardcodeada en producción)
// Si no tienes .env, usa una cadena fija (menos seguro)
const SECRET_KEY ='65a4sd165ad65a*/*asd564af_.,+sdfsdfwewrwerwerqwrpepe';

/**
 * Cifra un objeto o string
 * @param {*} data - Objeto o string a cifrar
 * @returns {string} Texto cifrado en base64
 */
export const encryptData = (data) => {
  const jsonString = typeof data === 'string' ? data : JSON.stringify(data);
  return CryptoJS.AES.encrypt(jsonString, SECRET_KEY).toString();
};

/**
 * Descifra un texto cifrado
 * @param {string} encrypted - Texto cifrado en base64
 * @returns {Object|string|null} Objeto descifrado o null si falla
 */
export const decryptData = (encrypted) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    // Intentar parsear como JSON, si falla devolver el string
    try {
      return JSON.parse(decryptedString);
    } catch {
      return decryptedString;
    }
  } catch (error) {
    console.error('Error al descifrar datos:', error);
    return null;
  }
};